module.exports = __webpack_public_path__ + "img/engineering__alien.83588316.svg";